import Annotation from '../Annotation';
import subpixel from '../util/canvasSubpixelOffset';

/** Rectangle Annotation */
export default class RectangleAnnotation extends Annotation {
	_getDefaultParams() {
		return {
			start: { date: null, value: null, x: null, y: null },
			stop: { date: null, value: null, x: null, y: null },
			style: this.core.getStyle('annotation.rectangle')
		};
	}

	render() {
		const ctx = this.panel.rootContext;
		const panel = this.panel;
		const params = this.params;
		const style = params.style;
		const xScale = panel.xAxis.primaryScale;
		const x0 = typeof params.start.x === 'number' ? params.start.x : xScale(this.core.closestExchangeIndex(new Date(params.start.date)));
		const x1 = typeof params.stop.x === 'number' ? params.stop.x : xScale(this.core.closestExchangeIndex(new Date(params.stop.date)));
		const y0 = params.start.y;
		const y1 = params.stop.y;
		ctx.setLineDash(style.lineDash.split(/\s*,\s*/));
		ctx.lineWidth = style.width;
		ctx.beginPath();

		// rectangle path
		subpixel.rect(ctx, x0, y0, x1 - x0, y1 - y0);

		// fill
		if (style.background.color) {
			ctx.fillStyle = style.background.color;
			ctx.fill();
		}

		// overall border
		if (style.color) {
			ctx.strokeStyle = style.color;
			ctx.stroke();
		}

		// individual border sides
		if (style.top.color) {
			this._renderSide(
				[x0, y0],
				[x1, y0],
				style.top.color
			);
		}

		if (style.right.color) {
			this._renderSide(
				[x1, y0],
				[x1, y1],
				style.right.color
			);
		}

		if (style.bottom.color) {
			this._renderSide(
				[x0, y1],
				[x1, y1],
				style.bottom.color
			);
		}

		if (style.left.color) {
			this._renderSide(
				[x0, y0],
				[x0, y1],
				style.left.color
			);
		}

		ctx.setLineDash([]);
	}

	_renderSide(start, stop, color) {
		const ctx = this.panel.rootContext;
		ctx.strokeStyle = color;
		ctx.beginPath();
		ctx.moveTo(subpixel.px(start[0]), subpixel.px(start[1]));
		ctx.lineTo(subpixel.px(stop[0]), subpixel.px(stop[1]));
		ctx.stroke();
		ctx.closePath();
	}
}
